<template>
  <div>
    <el-dialog :show-close="false" :visible="dialogVisibleState" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="close" :width="'620px'">
      <template #title>
        <div class="dialog-title-box">
          <span>{{ $t('message.subscription.cancelSubsDialogTitle') }}</span>
          <rhcn-button class="icon-button dialog-close-icon" size="small" @click="dialogVisibleState = false"><i
              class="el-icon-close"></i></rhcn-button>
        </div>
      </template>

      <el-radio-group v-model="radioTypeState" @change="handleRadioChange">
        <el-radio v-if="!showImmediatelyState" :label="2">{{ $t('message.subscription.cancelSubsBtn1') }}</el-radio>
        <el-radio v-if="!showImmediatelyState" :label="3">{{ $t('message.subscription.cancelSubsBtn2') }}</el-radio>
        <el-radio :label="1">{{ $t('message.subscription.cancelSubsBtn3') }}</el-radio>
      </el-radio-group>
      <br>

      <RhcnDatepicker :picker-options="datePickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
        style="width: 300px;margin: 15px 0;" v-if="radioTypeState === 3" v-model="submitParamState.expireDate">
      </RhcnDatepicker>
      <div class="divider"></div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="btn" type="primary" @click="submitClick" :loading="btnLoadingState">{{
            $t('message.common.confirm') }}</el-button>
          <el-button class="btn" @click="close">{{ $t('message.tableCommon.cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>

    <custom-message ref="customMessageRefState"></custom-message>

  </div>
</template>

<script>
import moment from 'moment';

import RhcnButton from '@/components/form/button.vue';
import RhcnDatepicker from '@/components/form/datepicker.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { unsubscribeV2 } from '@/views/subscription/api/subscription';
export default {
  components: {
    RhcnDatepicker,
    RhcnButton,
    CustomMessage,
  },
  data() {
    return {
      date: undefined,
      btnLoadingState: false,
      radioTypeState: 1,
      detailState: {},
      submitParamState: {
        contractId: '',
        expireDate: undefined,
      },
      dialogVisibleState: false,
    };
  },
  computed: {
    datePickerOptions() {
      return {
        disabledDate: (time) => {
          const currentTime = Date.now();
          const expireTime = new Date(this.detailState.expireDate || '').getTime();
          return currentTime > time.getTime() || time.getTime() > expireTime;
        },
      };
    },
    // 挽留弹窗展示的时间
    dialogExpireDate() {
      // 如果立即取消，那时间就是当天
      if (this.radioTypeState === 1) {
        return moment().format('YYYY-MM-DD');
      }
      if (this.radioTypeState === 3) {
        return this.submitParamState.expireDate;
      }
      return moment(this.detailState.billingCycleAnchor || this.detailState.expireDate).add(-1).format('YYYY-MM-DD');
    },

    // 二次弹窗 多语言挽留文本
    cancelContentHtml() {
      const { merchantCustId, website, productName } = this.detailState;
      const mapper = {
        'zh-cn': `<div style="text-align:left;"><div>确定取消用户：${merchantCustId}在${website} 订阅的${productName}吗？</div><br/><div>取消该顾客的服务将于<span style="color: red;"> ${this.dialogExpireDate} </span>终止</div></div>`,
        en: `<div style="text-align:left;"><div>Confirm cancellation of user${merchantCustId}'s subscription to ${productName} at ${website}?</div><br/><div>Service will end on<span style="color: red;"> ${this.dialogExpireDate} </span></div></div>`,
      };

      return mapper[this.$store.getters.app.currentLan] || mapper.en;
    },

    // 是否只显示立即取消
    showImmediatelyState() {
      // selfExecute = 2的时候（商户扣款） 只展示立即取消
      if (this.detailState.selfExecute === '2') {
        return true;
      }

      //   active 取消 生效中取消 只展示立即取消；
      // pastdue 启用 逾期未付 都展示只展示立即取消；
      // paused 启用 暂停中 只展示立即取消
      const { dataStatus, subscriptionStatus } = this.detailState;
      if (
        (dataStatus === '3' && subscriptionStatus === 'active') ||
        (dataStatus === '1' && subscriptionStatus === 'pastdue') ||
        (dataStatus === '1' && subscriptionStatus === 'paused')
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    open(contractId, detailState) {
      this.radioTypeState = 1;
      this.submitParamState = {
        contractId: '',
        expireDate: undefined,
      };
      this.dialogVisibleState = true;

      this.detailState = detailState;
      this.submitParamState.contractId = contractId;
    },
    handleRadioChange() {
      if (this.radioTypeState === 3) {
        this.submitParamState.expireDate = undefined;
      }
    },

    close() {
      this.dialogVisibleState = false;
    },
    async submitClick() {
      // 如果指定日期，那时间就必填
      if (this.radioTypeState === 3 && !this.submitParamState.expireDate) {
        ShowWarningMessage(this.$t('message.subscription.pickDateTip'));
        return;
      }
      if (this.radioTypeState === 1) {
        this.submitParamState.expireDate = undefined;
      }
      if (this.radioTypeState === 2) {
        // 立即取消 日期传参是今日
        this.submitParamState.expireDate = moment().format('yyyy-MM-DD');
      }
      //     IMMEDIATELY("1", "立即"),
      // CURRENT_CYCLE("2", "到期"),
      // SPECIFIED("3", "指定"),
      this.submitParamState.expireMode = this.radioTypeState;
      this.$refs.customMessageRefState.openHttpModal({
        titleHtml: this.$t('message.subscription.cancelSubsDialogTitle'),
        contentHtml: this.cancelContentHtml,
        httpFunction: unsubscribeV2,
        params: this.submitParamState,
        successFunction: () => {
          this.close();
          this.$emit('success');
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: start;
}

.divider {
  width: 100%;
  height: 1px;
  background: #EFEFF4;
  margin-top: 24px;
}

.btn {
  width: 80px !important;
  height: 38px !important;
}

.dialog-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  .dialog-close-icon {
    font-size: 23px;
    width: 27px !important;
    height: 27px !important;
    min-width: 27px !important;
    border-radius: 4px;
    cursor: pointer;

    span {
      display: inline-block;
      width: 20px;
      height: 20px;
      display: flex;
    }

    .el-icon-close {
      font-weight: bold;
      font-size: 20px;
      display: inline-block;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
